import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AuthContextType {
  clientSecret: string | null;
  clientName: string | null;
  setAuth: (secret: string, name?: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [clientSecret, setClientSecret] = useState<string | null>(
    localStorage.getItem('clientSecret')
  );
  const [clientName, setClientName] = useState<string | null>(
    localStorage.getItem('clientName')
  );

  const setAuth = (secret: string, name?: string) => {
    setClientSecret(secret);
    localStorage.setItem('clientSecret', secret);
    if (name) {
      setClientName(name);
      localStorage.setItem('clientName', name);
    }
  };

  const logout = () => {
    setClientSecret(null);
    setClientName(null);
    localStorage.removeItem('clientSecret');
    localStorage.removeItem('clientName');
  };

  return (
    <AuthContext.Provider value={{ clientSecret, clientName, setAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};